"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const CardRequirementsComponent_vue_1 = require("./CardRequirementsComponent.vue");
const CardVictoryPoints_vue_1 = require("./CardVictoryPoints.vue");
const CardDescription_vue_1 = require("./CardDescription.vue");
const CardRenderData_vue_1 = require("./CardRenderData.vue");
const Types_1 = require("@/common/cards/render/Types");
exports.default = vue_1.default.extend({
    name: 'CardContent',
    props: {
        metadata: {
            type: Object,
            required: true,
        },
        requirements: {
            type: (Array),
        },
        isCorporation: {
            type: Boolean,
            required: true,
        },
        padBottom: {
            type: Boolean,
        },
    },
    components: {
        CardRequirementsComponent: CardRequirementsComponent_vue_1.default,
        CardVictoryPoints: CardVictoryPoints_vue_1.default,
        CardDescription: CardDescription_vue_1.default,
        CardRenderData: CardRenderData_vue_1.default,
    },
    methods: {},
    computed: {
        classes() {
            const classes = ['card-content'];
            if (this.isCorporation) {
                classes.push('card-content-corporation');
            }
            return classes.join(' ');
        },
        hasDescription() {
            const description = this.metadata.description;
            return description !== undefined && (typeof (description) !== 'string' || description.length > 0);
        },
        firstRow() {
            if ((0, Types_1.isICardRenderRoot)(this.metadata.renderData) && this.metadata.renderData.rows.length > 0) {
                return {
                    is: 'root',
                    rows: [this.metadata.renderData.rows[0]],
                };
            }
            return undefined;
        },
        remainingRows() {
            if ((0, Types_1.isICardRenderRoot)(this.metadata.renderData) && this.metadata.renderData.rows.length > 1) {
                return {
                    is: 'root',
                    rows: this.metadata.renderData.rows.slice(1),
                };
            }
            return undefined;
        },
    },
});
